export default class Hamburger {
	constructor () {
    this.hamburger = document.querySelector('.hamburger');
    this.hamburgerBtn = document.querySelector('.hamburger-button');
    this.menu = document.querySelector('.hamburger + .hamburger-container');
    this.elementsToInert = document.querySelectorAll('#skipToMain, main, footer');
    this.onKeydownCallback = this.onKeydown.bind(this);
		this.init();
	}

	init() {
    if(!this.hamburger) return;

    this.hamburgerBtn.addEventListener('click', () => {
      const isOpen = this.hamburger.classList.contains('active');

      if (!isOpen) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    });
	}

  onKeydown (e) {
    if(e.key === 'Escape') {
      this.closeMenu();
    }
  }

  openMenu () {
    document.body.classList.add('overflow-hidden');
    this.hamburger.classList.add('active');
    this.menu.classList.add('active');
    this.hamburgerBtn.setAttribute('aria-label', this.hamburgerBtn.dataset.closeLabel);
    this.menu.removeAttribute('inert');

    this.elementsToInert.forEach(el => {
      el.setAttribute('inert', 'true');
    });

    document.addEventListener('keydown', this.onKeydownCallback);
  }

  closeMenu () {
    document.body.classList.remove('overflow-hidden');
    this.hamburger.classList.remove('active');
    this.menu.classList.remove('active');
    this.hamburgerBtn.setAttribute('aria-label', this.hamburgerBtn.dataset.openLabel);
    this.hamburgerBtn.focus();
    this.menu.setAttribute('inert', 'true');

    this.elementsToInert.forEach(el => {
      el.removeAttribute('inert');
    });

    document.removeEventListener('keydown', this.onKeydownCallback);
  }
}
